<template>
    <div class="input_box">
        <input type="text" id="search_sp" v-model="searchText" placeholder="品番で検索">
        <label for="search_sp">
            <img src="../assets/images/search_2_line.svg" alt="search_icon">
        </label>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'

    export default {
        name: "SearchInputSp",
        props: {
        },
        data: () => ({
        }),
        computed: {
            ...mapState('search', ["search_text"]),
            searchText: {
                get() {
                    return this.search_text;
                },
                set(value) {
                    this.updateSearchText(value.trim());
                }
            }
        },
        created() {
        },
        watch: {
        },
        methods: {
            ...mapMutations('search', ['updateSearchText']),
        }
    }
</script>

<style scoped lang="scss">
    .input_box {
        position: relative;
        border: solid 1px #826E67;
        border-radius: 4px;
        box-sizing: border-box;
        height: 22px;
        width: 129px;
        display: flex;
        align-items: center;
        input {
            font-size: 13px;
            width: 100px;
            border: none;
            color: #826E67;
            padding-left: 5px;
            &:focus {
                outline: none;
            }
        }
        img {
            position: absolute;
            right: 0;
            top: 0;
            width: 22px !important;
        }
    }
</style>
